module.exports = __webpack_public_path__ + "static/media/002.9a16c248.jpg";